@if (dataLoaded) {
  <div class="flex items-end gap-2 mb-3">
    <div class="flex flex-col">
      <label for="sortColumn">Sortieren nach:</label>
      <p-select
        id="sortColumn"
        [options]="sortOptions"
        [(ngModel)]="selectedSortField"
        (onChange)="onSortChange()"
        optionLabel="label"
        optionValue="value"
        placeholder="Spalte wählen"
      ></p-select>
    </div>
    <p-select
      id="sortDirection"
      [options]="sortDirectionOptions"
      [(ngModel)]="sortOrder"
      optionLabel="label"
      optionValue="value"
    ></p-select>
    <label class="flex items-center gap-1 cursor-pointer">
      <input type="checkbox" [(ngModel)]="showAverageColumn" />
      Ø
    </label>
    <div class="ml-auto self-start flex gap-2">
      <p-button icon="pi pi-file-export" label="Namensliste" severity="secondary" (onClick)="exportPlayerNames()" [outlined]="true" size="small"></p-button>
      <p-button icon="pi pi-file-export" label="Als Bild" severity="secondary" (onClick)="exportAsImage()" [outlined]="true" size="small"></p-button>
    </div>
  </div>
}
<div class="flex justify-center">
  <div class="inline-block shadow-2xl rounded-lg overflow-hidden" #tableWrapper>
    @if (dataLoaded) {
      <p-table
        #dt1
        class="racing-table"
        [rowClass]="getPodiumClass(playerList)"
        [value]="playerList"
        dataKey="player_id"
        [rowHover]="true"
        [showGridlines]="false"
        [globalFilterFields]="['name_gt7', 'final_position', 'car_name', 'average_points_v3']"
        responsiveLayout="scroll"
        size="small"
        [sortField]="selectedSortField"
        [sortOrder]="sortOrder"
        >
        <ng-template #header let-player>
          <tr>
            <th [attr.colspan]="getHeaderColspan()" class="table-header" style="text-align: center;">
              Liga Tabelle - {{ seasonName || 'Season ' + season }}
            </th>
          </tr>
          <tr>
            @if (showAverageColumn) {
              <th style="text-align: center;">
                #
              </th>
            }
            <th style="text-align: center;">
              <i class="pi pi-flag"></i>
            </th>
            <th style="min-width: 19rem">
              <i class="pi pi-user"></i> Fahrer
            </th>
            <th style="text-align: center;">
              ∑
            </th>
            <th style="text-align: center;">
              <i class="pi pi-trophy"></i>
            </th>
            <th style="text-align: center;">
              Top 5
            </th>
            @for (raceDay of raceDays; track raceDay) {
              <th style="text-align: center;">
                <i class="pi pi-calendar"></i> {{ raceDay.day_real | date: 'dd.MM.yy' }}
              </th>
            }
            @if (showAverageColumn) {
              <th style="text-align: center;">
                <i class="pi"></i> Ø
              </th>
            }
          </tr>
        </ng-template>
        <ng-template #body let-player let-rowIndex="rowIndex">
          <tr [routerLink]="['/playerDetails', player.player_id]" style="cursor: pointer;">
            @if (showAverageColumn) {
              <td >
                {{ rowIndex + 1 }}
              </td>
            }
            <td class="index-cell" style="text-align: center;">
              P{{ player.final_position }}
            </td>
            <td>
              <b>{{ player.name_gt7 }}</b>
              @if (player.name_gt7 !== player.name_psn) {
                <span class="text-surface-400 text-sm ml-1">(PSN: {{ player.name_psn }})</span>
              }
              <br><span class="car-name">{{ player.car_name }}</span>
            </td>
            <td style="text-align: center">
              <b>{{ player.points_total }}</b>
            </td>
            <td>
              <b>{{ player.win_count }}</b>
            </td>
            <td style="text-align: center">
              <b>{{ player.top5_count }}</b>
            </td>
            @for (raceDay of raceDays; track raceDay) {
              <td>
                @if (raceDay.day_planned && hasDayRacePoints(player.player_id, raceDay.day_planned)) {
                  <div>
                    {{ getDayRacePoints(player.player_id, raceDay.day_planned) }}
                  </div>
                }
                @if (raceDay.day_planned && !hasDayRacePoints(player.player_id, raceDay.day_planned)) {
                  <div>
                    -
                  </div>
                }
              </td>
            }
            @if (showAverageColumn) {
              <td style="text-align: center">
                <b>{{ player.average_points_v3 | number:'1.2-2' }}</b>
              </td>
            }
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="8">Keine Renndaten vorhanden</td>
          </tr>
        </ng-template>
        <ng-template #loadingbody>
          <tr>
            <td colspan="8">Lade Daten ...</td>
          </tr>
        </ng-template>
      </p-table>
    }
  </div>
</div>
@if (!dataLoaded) {
  <div>Lade Daten ...</div>
}